import { Icon, MenuItem, Position } from "@blueprintjs/core"
import { Select } from "@blueprintjs/select"
import { get } from "lodash-es"
import {
  arrayOf,
  bool,
  element,
  func,
  instanceOf,
  number,
  object,
  oneOfType,
  string,
} from "prop-types"
import React, { useCallback } from "react"
import { withFormController } from "../Molecules/FormController"
import CustomButton from "./CustomButton"
import CustomFormGroup from "./CustomFormGroup"
import classNames from "utils/classNames"
/*
CustomStaticSelector

renderText: takes an selectedItem Object as its parameter, and returns a string value to display

*/

const CustomStaticSelector = ({
  icon,
  label,
  labelInfo,
  helperText,
  formGroupProps,
  value: selectedItem,
  loading,
  path,
  error,
  onChange,
  searchVector,
  itemRenderer,
  items,
  children,
  extraItems,
  rightIcon,
  renderText,
  fill,
  resetOnSelect,
  labelElement,
  className,
  inline,
  name,
  id,
  onCreate,
  btnClassName,
  big,
  required,
  disabled,
  popoverClassName,
  popoverProps,
  ...otherSelectorProps
}) => {
  const filterItem = (query, item) => {
    try {
      const regExp = new RegExp(query, "i")
      let flag = false
      searchVector.forEach(search => {
        const property = get(item, search)
        if (regExp.test(property)) return (flag = true)
      })
      if (flag) return item
    } catch (err) {
      // IF Any error occurs, lets say that the user inputs a regex itself
      // Then return the item to be on the safer side
      // Return item
      return item
    }
  }
  const handleSelect = item => {
    if (item.id === "vt_selector_blank") {
      onChange(path, null)
    } else {
      onChange(path, item)
    }
  }

  //  Add a blank selector to the top of the items list and append extra items after the
  // List of regular items
  const itemsList = items ? items.concat(extraItems) : []

  const renderNewItem = query => (
    <MenuItem text={query} icon="add" onClick={e => onCreate(query)} />
  )

  const createNewItem = useCallback(() => null, [])

  return (
    <CustomFormGroup
      disabled={disabled}
      big={big}
      className={className}
      label={label}
      labelInfo={labelInfo}
      helperText={helperText}
      error={error}
      inline={inline}
      required={required}
      {...formGroupProps}
    >
      <Select
        disabled={disabled}
        createNewItemFromQuery={onCreate ? createNewItem : undefined}
        createNewItemRenderer={renderNewItem}
        className="vt-static-selector-fill"
        items={itemsList}
        noResults={<MenuItem key="empty" disabled={true} text="No results." />}
        resetOnSelect={resetOnSelect}
        itemRenderer={(item, { handleClick, modifiers }) =>
          itemRenderer(item, { handleClick, modifiers }, labelElement, name)
        }
        itemPredicate={filterItem}
        onItemSelect={handleSelect}
        popoverProps={{
          minimal: true,
          position: Position.BOTTOM_LEFT,
          popoverClassName,
          ...popoverProps,
        }}
        {...otherSelectorProps}
      >
        {children ? (
          children?.(selectedItem)
        ) : (
          <CustomButton
            icon={icon}
            disabled={disabled}
            style={{
              height: big ? "2.3rem" : null,
            }}
            id={id}
            rightIcon={rightIcon}
            className={classNames("vt-selector-button", btnClassName)}
            loading={loading}
            fill={fill}
          >
            {renderText(selectedItem, name)}
          </CustomButton>
        )}
      </Select>
    </CustomFormGroup>
  )
}
CustomStaticSelector.defaultProps = {
  value: {},
  itemRenderer: (item, { handleClick, modifiers }, labelElement, name) => {
    return (
      <MenuItem
        active={modifiers.active}
        key={item.id}
        onClick={handleClick}
        text={get(item, name)}
        labelElement={get(item, labelElement, null)}
      />
    )
  },
  renderText: (selectedItem, name) => get(selectedItem, name, "Select..."),
  valueAs: "int",
  searchVector: ["name"],
  name: ["name"],
  rightIcon: "caret-down",
  fill: true,
  resetOnSelect: true,
}

CustomStaticSelector.propTypes = {
  name: oneOfType([string, arrayOf(string)]),
  label: oneOfType([string, element]),
  labelInfo: oneOfType([string, element]),
  helperText: oneOfType([string, element]),
  formGroupProps: object,
  value: oneOfType([object, string, number]),
  loading: bool,
  path: oneOfType([arrayOf(oneOfType([string, number])), string]),
  error: string,
  onChange: func,
  searchVector: arrayOf(string),
  itemRenderer: func,
  items: arrayOf(object),
  extraItems: arrayOf(object),
  renderText: func,
  rightIcon: oneOfType([string, instanceOf(Icon)]),
  fill: bool,
  resetOnSelect: bool,
}
export default withFormController(CustomStaticSelector)
